<template>
  <div class="wrap">
    <!-- <video
      class="wrapVideo"
      poster="https://p2.ssl.qhimg.com/t0107d160307a26ce7f.png"
      autoplay
      muted
      loop
      playsinline
    >
      <source
        src="https://video.isc.360.com/vod-iscvideo-vod-101179-beijing/TL38d747c45fbd16679b6f2a4725dc6278.mp4"
        type="video/mp4"
      />
      您的浏览器不支持 video 标签。
    </video>
    <div class="wrapMask"></div>
    <img class="wrapText" src="https://p2.ssl.qhimg.com/t01d5b9580f3cbcc41b.png" alt="文字" /> -->
    <img src="https://p2.ssl.qhimg.com/t0124d766206e239bd6.jpg" alt="首页图" class="picture">
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.wrap {
  min-width: 1280px;
}

.picture {
  width: 100%;
  height: 100%;
}
// .wrap {
//   position: relative;
//   width: 100%;
//   overflow: hidden;
//   text-align: center;
//   &Video {
//     width: auto;
//     height: 100%;
//   }
//   &Mask {
//     position: absolute;
//     top: 0;
//     width: 100%;
//     height: 1080px;
//     background-color: rgba(0, 0, 0, 0.5);
//   }
//   &Text {
//     position: absolute;
//     top: 50%;
//     left: 50%;
//     transform: translate(-50%, -50%);
//     width: 576px;
//   }
// }
</style>
